

export const englishUser = {
  searchTitle: "Find Your Nearest Driving School",
  district: "District",
  nearestCity: "Nearest City",
  selectDistrict: "Select Your District",
  selectCity: "Select Your City",
  freeTitle: "Free Register Your Driving School Here",
  regBtn: "Register Now",
};

export const sinhalaUser = {
  searchTitle: "ඔබගේ ආසන්නම රියැදුරු පාසල සොයා ගන්න",
  district: "දිස්ත්‍රික්කය",
  nearestCity: "ආසන්න නගරය",
  selectDistrict: "ඔබගේ දිස්ත්‍රික්කය තෝරන්න",
  selectCity: "ඔබගේ නගරය තෝරන්න",
  freeTitle: "ඔබගේ රියැදුරු පාසල නොමිලේ ලියාපදිංචි කරන්න",
  regBtn: "දැන්ම ලියාපදිංචි වන්න",
};

export const tamilUser = {
  searchTitle: "உங்கள் அருகிலுள்ள வாகன ஓட்டுநர் பள்ளியைத் தேடுங்கள்",
  district: "மாவட்டம்",
  nearestCity: "அருகிலுள்ள நகரம்",
  selectDistrict: "உங்கள் மாவட்டத்தைத் தேர்ந்தெடுக்கவும்",
  selectCity: "உங்கள் நகரத்தைத் தேர்ந்தெடுக்கவும்",
  freeTitle: "இங்கே உங்கள் வாகன ஓட்டுநர் பள்ளியை இலவசமாக பதிவு செய்யவும்",
  regBtn: "இப்போது பதிவு செய்யவும்",
};

